import _classCallCheck from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.array.push.js";
import router from "@/router";
export var Navigation = /*#__PURE__*/function () {
  function Navigation() {
    _classCallCheck(this, Navigation);
  }
  return _createClass(Navigation, [{
    key: "push",
    value:
    // 推送到一个新的地址
    function push(location, onComplete, onAbort) {
      return router.push(location, onComplete, onAbort);
    }

    // 重定向到登录页面
  }, {
    key: "toLogin",
    value: function toLogin() {
      this.push({
        name: "v2-login"
      });
    }

    // 重定向到首页页面
  }, {
    key: "toIndex",
    value: function toIndex() {
      this.push({
        name: "home"
      });
    }

    // 重定向到公告页面
  }, {
    key: "toNotice",
    value: function toNotice() {
      this.push({
        name: "notice"
      });
    }
  }]);
}();